var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDown = function SvgDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M40 61a1 1 0 0 0 .719-.305l29-30a1 1 0 0 0-1.438-1.39L40 58.561 11.719 29.305a1 1 0 0 0-1.438 1.39l29 30A1 1 0 0 0 40 61",
    clipRule: "evenodd"
  })));
};
export default SvgDown;